import React from "react";
import dynamic from "next/dynamic";
import { StoreTemplate } from "@/templates/TemplateLoader";
import { FormattedDataType } from "@/templates/types";
import { Config } from "react-player";

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false });

interface VideoCardProps {
  isSliderSection?: boolean;
  section: Partial<FormattedDataType>;
  link: FormattedDataType["links"][0];
}

const VideoCard: React.FC<VideoCardProps> = ({
  section,
  isSliderSection,
  link,
}) => {
  const Template = StoreTemplate.get();
  // Platform-specific config to support all video platforms
  const config: Config = {
    vimeo: {
      playerOptions: {
        dnt: true,
        controls: true,
      },
    },
  };

  return (
    <Template.SectionCardWrapper
      isSlider={isSliderSection}
      data-test="link-card"
      background={section?.background}
    >
      <div className="w-full h-auto">
        <ReactPlayer url={link} width="100%" height="100%" config={config} />
      </div>
    </Template.SectionCardWrapper>
  );
};

export default VideoCard;
